import { render, staticRenderFns } from "./m-orm-card-dialog.vue?vue&type=template&id=1e1b7058&lang=pug&"
import script from "./m-orm-card-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-card-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-card-dialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports